module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('store-table')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a2a363"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/History/StoreHistoryTable.vue
// module id = 2325
// module chunks = 1